import axios from "src/utils/axios";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    autocomplete: "/address/automation",
    autocompleteSelectOption: "/address/details",
    //
    verifyAddress: "/address/validate"
};

// ----------------------------------------------------------------------

const getAutocompleteAddress = (request) => axios.post(API_ENDPOINTS.autocomplete, { ...request });

const selectAutocompleteAddress = (request) => axios.post(API_ENDPOINTS.autocompleteSelectOption, { ...request });

const verifyAddress = (request) => axios.post(API_ENDPOINTS.verifyAddress, { ...request });

// ----------------------------------------------------------------------

export {
    getAutocompleteAddress as getAutocompleteAddressAPI,
    selectAutocompleteAddress as selectAutocompleteAddressAPI,
    //
    verifyAddress as verifyAddressAPI
};
